<template>
  <section class="my-4">
    <h2>アカウント設定 / Account settings</h2>
    <p>登録したユーザー名とパスワードで、KIROKUNアプリにログインしてください。アンケートにはアプリで回答します。</p>
    <p lang="en">Sign in to the KIROKUN app with your username and password to answer surveys.</p>
    <p v-if="features.googleRegistration">Googleとの連携は任意です。同じKIROKUNアカウントにGoogleでログインする方法を追加します。別のKIROKUNアカウントは作りません。 / Linking Google is optional. It adds a sign-in method to this same account; it does not create another KIROKUN account.</p>
    <button v-if="features.googleRegistration" class="btn btn-primary" @click="linkGoogle" :disabled="busy">{{busy ? '確認中… / Checking…' : 'Googleログインを追加 / Link Google'}}</button>
    <p v-if="message" role="status">{{message}}</p>
    <router-link to="/login">ログイン画面へ / Go to sign in</router-link>
  </section>
</template>
<script>
import accountFeatures from '../mixins/accountFeatures';
import * as firebase from 'firebase/app';
import 'firebase/auth';
export default {
  mixins: [accountFeatures],
  data: () => ({busy: false, message: ''}),
  methods: {
    async linkGoogle() {
      if (!this.features.googleRegistration || this.busy) return;
      const user = firebase.auth().currentUser;
      if (!user) { this.message = '先にログインしてください。'; return; }
      if (user.providerData.some(p => p.providerId === 'google.com')) { this.message = 'Googleログインは登録済みです。'; return; }
      this.busy = true; this.message = '';
      try {
        const provider = new firebase.auth.GoogleAuthProvider();
        provider.setCustomParameters({prompt: 'select_account'});
        await user.linkWithPopup(provider);
        this.message = '同じアカウントでGoogleログインが利用できるようになりました。';
      } catch (e) {
        this.message = e.code === 'auth/credential-already-in-use'
          ? 'このGoogleアカウントは別の利用者に登録されています。上松さんにお問い合わせください。'
          : 'Googleログインを追加できませんでした。再度お試しください。';
      } finally { this.busy = false; }
    }
  }
};
</script>
